import { RefreshCcw } from 'lucide-react';
import { useRef, useState } from 'react';
import { MAX_FILE_SIZE_MB } from '../constants';
import { formatFileSize, showErrorToast, validateFileSize } from '../utils';

interface ImageInputProps {
  disabled: boolean;
  className?: string;
}

export const AudioInput = ({ disabled, className }: ImageInputProps) => {
  const fileRef = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState('');

  const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!validateFileSize(file)) {
      showErrorToast(
        `File size must not exceed ${MAX_FILE_SIZE_MB}MB. Current size: ${formatFileSize(
          file.size,
        )}`,
      );
      if (fileRef.current) fileRef.current.value = '';
      return;
    }

    setFileName(file.name);
  };

  const reset = () => {
    setFileName('');
    if (fileRef.current) fileRef.current.value = '';
  };

  return (
    <div className="flex items-center gap-2 w-full">
      {/* Hidden file input */}
      <input
        ref={fileRef}
        type="file"
        accept="audio/*"
        disabled={disabled}
        onChange={handleSelect}
        className="hidden border"
      />

      {/* Visible input */}
      <input
        type="text"
        readOnly
        value={fileName}
        placeholder={`Click here to upload file (<${MAX_FILE_SIZE_MB} MB)`}
        disabled={disabled}
        onClick={() => !disabled && fileRef.current?.click()}
        className={`${className} cursor-pointer  rounded-md w-2/4 px-2 py-1 bg-transparent border border-[#C0275E] placeholder:text-[#C0275E] `}
      />

      {/* Reset icon */}
      <button type="button" onClick={reset} disabled={disabled} className="text-[#7a3a4c]">
        <RefreshCcw size={18} />
      </button>
    </div>
  );
};
